module.exports = __webpack_public_path__ + "img/job-banner.7ec8ab56.png";